/**
 * Module for automatically detecting the country based on the IP address.
 * Saves the full country name to a hidden input field and
 * automatically switches the area selection (ha / acres) for the US, CA, GB, and IE.
 */
export function initAutoCountryAndArea() {
	const API_URL = "https://ipapi.co/json/";
	const IP_INPUT_SELECTOR = 'input[name="user-ip"]';
	const AREA_SELECT_SELECTOR = "#area";

	const ACRES_COUNTRIES = ["US", "CA", "GB", "IE"];

	const ipInputs = document.querySelectorAll(IP_INPUT_SELECTOR);
	const $areaSelect = jQuery(AREA_SELECT_SELECTOR);

	if (!$areaSelect.length && ipInputs.length === 0) return;

	fetch(API_URL)
		.then((response) => {
			if (!response.ok) throw new Error(`HTTP ${response.status}`);
			return response.json();
		})
		.then((data) => {
			if (!data) return;

			if (data.ip && ipInputs.length > 0) {
				ipInputs.forEach((input) => {
					input.value = data.ip.trim();
				});
				// console.log(`[AutoCountry] IP field filled with: ${data.ip}`);
			}

			// Converting hectares to acres
			if (data.country_code && $areaSelect.length) {
				const currentCountryCode = data.country_code.toUpperCase();

				if (ACRES_COUNTRIES.includes(currentCountryCode)) {
					// console.log(`[AutoCountry] Country "${currentCountryCode}" uses acres. Updating select options...`);

					$areaSelect.find("option").each(function () {
						const $option = jQuery(this);
						const acresValue = $option.data("acres");
						if (acresValue) {
							$option.text(acresValue);
						}
					});

					if ($areaSelect.data("select2")) {
						$areaSelect.trigger("change.select2");
					}
				}
			}
		})
		.catch((error) => {
			// console.warn("[AutoCountry] Geo-detection or select updating failed:", error.message);
		});
}
